import { render, staticRenderFns } from "./AfterSalesEmail.vue?vue&type=template&id=184fb765&scoped=true&"
import script from "./AfterSalesEmail.vue?vue&type=script&lang=js&"
export * from "./AfterSalesEmail.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesEmail.vue?vue&type=style&index=0&id=184fb765&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184fb765",
  null
  
)

export default component.exports